// Shared constants across the application

// Project tiers - used to categorise projects by strategic importance.
// To add or rename a tier, update this list AND update the tier colours in utils.ts (getTierColor).
// Order here determines the order they appear in dropdowns and reports.
export const TIERS = ['Black Line', 'Winning', 'Stretch', 'License to Operate'] as const

// Project statuses - each entry is [internal value, display label].
// 'forecast'  = expected value, not yet counted in realised KPIs.
// 'complete'  = delivered, go-live date recorded, ledger auto-seeded - counts in realised KPIs.
// 'cancelled' = project did not proceed; excluded from both realised and forecast.
export const STATUSES = [
  ['forecast', 'Forecast'],
  ['complete', 'Complete'],
  ['cancelled', 'Cancelled'],
] as const
